import { render, staticRenderFns } from "./selectConsultModel.vue?vue&type=template&id=4fcd60a8&scoped=true&"
import script from "./selectConsultModel.vue?vue&type=script&lang=js&"
export * from "./selectConsultModel.vue?vue&type=script&lang=js&"
import style0 from "./selectConsultModel.vue?vue&type=style&index=0&id=4fcd60a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd60a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcd60a8')) {
      api.createRecord('4fcd60a8', component.options)
    } else {
      api.reload('4fcd60a8', component.options)
    }
    module.hot.accept("./selectConsultModel.vue?vue&type=template&id=4fcd60a8&scoped=true&", function () {
      api.rerender('4fcd60a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/selectConsultModel.vue"
export default component.exports